import getDynamicMenuPosition from '../../utils/getDynamicMenuPosition';
import React, { useState, lazy, Suspense, useEffect } from 'react';
import { useEditorView } from '@remirror/react';
import ShortcutMenu from '../ShortcutMenu';
import { Dropdown } from 'antd';

const MENU_WIDTH = 360;
const MENU_ITEM_HEIGHT = 48;
const GROUP_LABEL_HEIGHT = 54;
const MENU_HEIGHT = 370;

const VideoUploadModal = lazy(() => import('./../VideoUploadModal'));

const RemirrorShortcut = React.memo(
  ({
    fileId,
    workspaceId,
    organizationId,
    items,
    selectedItem,
    onClickHandler,
    open,
    range,
    openDialog,
    onDialogClose,
  }) => {
    const [placementMemory, setPlacementMemory] = useState(null);
    const editorView = useEditorView();

    useEffect(() => {
      setPlacementMemory(null);
    }, [open]);

    if (openDialog && (openDialog === 'video' || openDialog === 'image'))
      return (
        <Suspense fallback={null}>
          <VideoUploadModal
            open={openDialog}
            fileId={fileId}
            workspaceId={workspaceId}
            organizationId={organizationId}
            onClose={onDialogClose}
          />
        </Suspense>
      );

    if (!open) return null;

    const itemsLength = Object.values(items).flat().length;
    const menuMaxHeight = itemsLength * MENU_ITEM_HEIGHT + Object.keys(items)?.length * GROUP_LABEL_HEIGHT;
    const pos = getDynamicMenuPosition({
      coords: editorView.coordsAtPos(range?.from),
      maxWidth: MENU_WIDTH,
      maxHeight: itemsLength === 0 ? MENU_HEIGHT : Math.min(MENU_HEIGHT, menuMaxHeight),
      prevPlacement: placementMemory,
    });
    if (pos.placement !== placementMemory) {
      setPlacementMemory(pos.placement);
    }

    return (
      <>
        <Dropdown
          autoFocus
          destroyPopupOnHide
          overlayClassName={`cms-shortcut slash-shortcut-menu${Object.values(items)?.flat()?.length === 0 ? ' collapse' : ''}`}
          menu={{ items: items, selectable: true, selectedKeys: [selectedItem] }}
          dropdownRender={({ props }) => (
            <ShortcutMenu
              {...props}
              selectedOption={selectedItem}
              onClickHandler={onClickHandler}
              width={MENU_WIDTH}
              height={MENU_HEIGHT}
            />
          )}
          open={open}
          trigger={[]}
          placement="bottomLeft"
          overlayStyle={{
            '--shortcut-width': MENU_WIDTH,
            '--shortcut-height': MENU_HEIGHT,
            borderRadius: '0px',
            top: pos.placement === 'top' ? pos?.top - 10 : pos?.top + 5,
            left: pos?.left ?? 100,
          }}
        >
          <span style={{ position: 'absolute', left: '0px', top: '0px', zIndex: 1, pointerEvents: 'none' }}>
            &nbsp;
          </span>
        </Dropdown>
      </>
    );
  }
);

export default RemirrorShortcut;
